import { render, staticRenderFns } from "./purchasedListDetail.vue?vue&type=template&id=29c48605&"
import script from "./purchasedListDetail.vue?vue&type=script&lang=js&"
export * from "./purchasedListDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchasedListDetail.vue?vue&type=style&index=0&id=29c48605&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports